import React, { useCallback, useEffect, useState } from 'react';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { apiService } from '../services/api';

export function MetricsPage() {
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const text = await apiService.fetchMetrics();
      setBody(text || '(empty)');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load metrics');
      setBody('');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="metrics-panel">
      <div className="audit-log-header">
        <h2>Metrics</h2>
        <button type="button" className="button secondary" onClick={load} disabled={loading}>
          <RefreshOutlinedIcon fontSize="small" />
          Refresh
        </button>
      </div>
      {error && <div className="auth-error">{error}</div>}
      {loading && !error && <p>Loading metrics…</p>}
      {!loading && !error && (
        <pre className="metrics-pre">{body}</pre>
      )}
    </div>
  );
}
